<mat-card class="todo-card" appearance="raised">
  <mat-card-header>
    <div class="todo-card-header-row">
      <mat-card-title>{{ listName }}</mat-card-title>
      <button
        mat-stroked-button
        type="button"
        class="left-count-button"
        [attr.aria-label]="viewModeLabel"
        [attr.title]="viewModeLabel"
        (click)="onToggleViewMode()"
      >
        <mat-icon class="left-count-icon">{{ viewModeIcon }}</mat-icon>
        {{ remainingCount }} left
      </button>
    </div>
  </mat-card-header>

  <mat-card-content>
    <p *ngIf="!canWrite" class="status-text">Read-only mode for this shared list.</p>

    <div *ngIf="isLoading" class="loading-row" aria-live="polite" aria-label="Loading todos">
      <mat-progress-spinner
        class="loading-spinner"
        [diameter]="18"
        [strokeWidth]="3"
        mode="indeterminate"
        aria-hidden="true"
      ></mat-progress-spinner>
      <span class="loading-text">Loading todos...</span>
    </div>

    <ng-container *ngIf="!isSplitMode; else splitModeTpl">
      <ng-container
        *ngTemplateOutlet="
          blocksListTpl;
          context: {
            $implicit: visibleBlocks,
            listKey: viewMode === 'all' ? 'main' : 'filtered'
          }
        "
      ></ng-container>
    </ng-container>

    <ng-template #splitModeTpl>
      <div class="split-list">
        <div class="split-list-title">Todo</div>
        <ng-container
          *ngTemplateOutlet="blocksListTpl; context: { $implicit: todoBlocks, listKey: 'todo' }"
        ></ng-container>
        <mat-divider></mat-divider>
        <div class="split-list-title split-list-title-done">Done</div>
        <ng-container
          *ngTemplateOutlet="blocksListTpl; context: { $implicit: doneBlocks, listKey: 'done' }"
        ></ng-container>
      </div>
    </ng-template>

    <ng-template #blocksListTpl let-blocks let-listKey="listKey">
      <mat-list
        class="blocks-list"
        cdkDropList
        [id]="getRootDropListId(listKey)"
        [cdkDropListData]="blocks"
        [cdkDropListConnectedTo]="getConnectedDropListIds(listKey, blocks)"
        [cdkDropListDisabled]="!isReorderEnabled || listKey !== 'main'"
        (cdkDropListDropped)="onRootDrop($event)"
      >
        <ng-container *ngFor="let block of blocks; trackBy: trackBlock">
          <ng-container *ngIf="block.type === 'item'; else sectionBlockTpl">
            <div class="swipe-row" [class.swipe-row-open]="isRowSwiped(itemRowKey(block))">
              <div class="swipe-underlay">
                <button mat-button type="button" class="swipe-underlay-btn" [disabled]="!canWrite" (click)="onInlineEdit(block, $event)">
                  Edit
                </button>
                <button
                  mat-button
                  type="button"
                  class="swipe-underlay-btn swipe-underlay-btn-danger"
                  [disabled]="!canWrite"
                  (click)="onRemove(block, $event)"
                >
                  Delete
                </button>
              </div>
              <mat-list-item
                cdkDrag
                [cdkDragDisabled]="!isReorderEnabled || listKey !== 'main'"
                [cdkDragData]="block"
                class="todo-item"
                [class.todo-item-swiped]="isRowSwiped(itemRowKey(block))"
                (click)="onToggle(block, $event)"
                (keydown.enter)="onToggle(block)"
                (keydown.space)="onToggle(block); $event.preventDefault()"
                (touchstart)="onRowTouchStart($event, itemRowKey(block))"
                (touchmove)="onRowTouchMove($event, itemRowKey(block))"
                (touchend)="onRowTouchEnd()"
                (touchcancel)="onRowTouchEnd()"
                (contextmenu)="onItemContextMenu($event, block)"
                tabindex="0"
              >
                <button
                  mat-icon-button
                  matListItemIcon
                  type="button"
                  class="drag-handle drag-handle-left"
                  cdkDragHandle
                  [class.drag-handle-disabled]="!isReorderEnabled || listKey !== 'main'"
                  (click)="$event.stopPropagation()"
                >
                  <mat-icon>drag_handle</mat-icon>
                </button>
                <div matListItemTitle class="todo-title" [class.done]="block.completed">
                  <mat-icon class="todo-status-icon">{{ block.completed ? 'check_circle' : 'radio_button_unchecked' }}</mat-icon>
                  {{ block.title }}
                </div>
                <span matListItemMeta class="row-trailing-actions"> </span>
              </mat-list-item>
            </div>
          </ng-container>

          <ng-template #sectionBlockTpl>
            <ng-container *ngIf="isSectionBlock(block)">
              <div class="section-block section-tree" cdkDrag [cdkDragData]="block" [cdkDragDisabled]="!isReorderEnabled || listKey !== 'main'">
                <div
                  class="section-header"
                  (touchstart)="onRowTouchStart($event, sectionRowKey(block.id))"
                  (touchmove)="onRowTouchMove($event, sectionRowKey(block.id))"
                  (touchend)="onRowTouchEnd()"
                  (touchcancel)="onRowTouchEnd()"
                  (contextmenu)="onSectionContextMenu($event, block)"
                >
                  <button
                    mat-icon-button
                    type="button"
                    class="drag-handle drag-handle-left"
                    cdkDragHandle
                    [class.drag-handle-disabled]="!isReorderEnabled || listKey !== 'main'"
                    (click)="$event.stopPropagation()"
                    aria-label="Drag section"
                  >
                    <mat-icon>drag_handle</mat-icon>
                  </button>
                  <button mat-button type="button" class="section-toggle" (click)="toggleSection(block.id, $event)">
                    <mat-icon class="section-chevron">{{ isSectionCollapsed(block.id) ? 'chevron_right' : 'expand_more' }}</mat-icon>
                    <span class="section-label">{{ block.title }}</span>
                  </button>
                  <span class="section-count">
                    {{ sectionCounts(block).done }}/{{ sectionCounts(block).total }}
                  </span>
                </div>

                <mat-list
                  *ngIf="!isSectionCollapsed(block.id)"
                  class="section-items-dropzone section-children"
                  cdkDropList
                  [id]="getSectionDropListId(block.id, listKey)"
                  [cdkDropListData]="block.items"
                  [cdkDropListConnectedTo]="getConnectedDropListIds(listKey, blocks)"
                  [cdkDropListEnterPredicate]="canEnterSectionList"
                  [cdkDropListDisabled]="!isReorderEnabled || listKey !== 'main'"
                  (cdkDropListDropped)="onSectionDrop($event, block)"
                >
                  <div
                    *ngFor="let item of block.items; trackBy: trackItem"
                    class="swipe-row"
                    [class.swipe-row-open]="isRowSwiped(itemRowKey(item))"
                  >
                    <div class="swipe-underlay">
                      <button mat-button type="button" class="swipe-underlay-btn" [disabled]="!canWrite" (click)="onInlineEdit(item, $event)">
                        Edit
                      </button>
                      <button
                        mat-button
                        type="button"
                        class="swipe-underlay-btn swipe-underlay-btn-danger"
                        [disabled]="!canWrite"
                        (click)="onRemove(item, $event)"
                      >
                        Delete
                      </button>
                    </div>
                    <mat-list-item
                      cdkDrag
                      [cdkDragDisabled]="!isReorderEnabled || listKey !== 'main'"
                      [cdkDragData]="item"
                      class="todo-item"
                      [class.todo-item-swiped]="isRowSwiped(itemRowKey(item))"
                      (click)="onToggle(item, $event)"
                      (keydown.enter)="onToggle(item)"
                      (keydown.space)="onToggle(item); $event.preventDefault()"
                      (touchstart)="onRowTouchStart($event, itemRowKey(item))"
                      (touchmove)="onRowTouchMove($event, itemRowKey(item))"
                      (touchend)="onRowTouchEnd()"
                      (touchcancel)="onRowTouchEnd()"
                      (contextmenu)="onItemContextMenu($event, item)"
                      tabindex="0"
                    >
                      <button
                        mat-icon-button
                        matListItemIcon
                        type="button"
                        class="drag-handle drag-handle-left"
                        cdkDragHandle
                        [class.drag-handle-disabled]="!isReorderEnabled || listKey !== 'main'"
                        (click)="$event.stopPropagation()"
                      >
                        <mat-icon>drag_handle</mat-icon>
                      </button>
                      <div matListItemTitle class="todo-title" [class.done]="item.completed">
                        <mat-icon class="todo-status-icon">{{ item.completed ? 'check_circle' : 'radio_button_unchecked' }}</mat-icon>
                        {{ item.title }}
                      </div>
                      <span matListItemMeta class="row-trailing-actions"> </span>
                    </mat-list-item>
                  </div>
                  <div *ngIf="!block.items.length" class="empty-section-hint">Drop items here</div>
                </mat-list>
                <div *ngIf="isSectionCollapsed(block.id)" class="section-end-divider"></div>
              </div>
            </ng-container>
          </ng-template>
        </ng-container>
      </mat-list>
    </ng-template>
  </mat-card-content>
</mat-card>

<div
  *ngIf="contextMenu"
  class="context-menu"
  [style.left.px]="contextMenu.x"
  [style.top.px]="contextMenu.y"
  (click)="$event.stopPropagation()"
>
  <button type="button" class="context-menu-action" (click)="onContextEdit()">Edit</button>
  <button type="button" class="context-menu-action context-menu-action-danger" (click)="onContextDelete()">Delete</button>
</div>

<div class="edit-item-backdrop" *ngIf="editItemTarget" (click)="closeEditItemDialog()"></div>
<section class="edit-item-modal" *ngIf="editItemTarget" aria-label="Edit task dialog">
  <mat-card appearance="raised" class="edit-item-card" (click)="$event.stopPropagation()">
    <mat-card-header>
      <mat-card-title>Edit task</mat-card-title>
    </mat-card-header>
    <mat-card-content>
      <mat-form-field appearance="outline" subscriptSizing="dynamic" class="edit-item-field">
        <mat-label>Task title</mat-label>
        <input matInput [(ngModel)]="editItemTitle" (keydown.enter)="submitEditItemDialog()" />
      </mat-form-field>
    </mat-card-content>
    <mat-card-actions align="end">
      <button mat-button type="button" (click)="closeEditItemDialog()">Cancel</button>
      <button mat-flat-button color="primary" type="button" [disabled]="!editItemTitle.trim()" (click)="submitEditItemDialog()">
        Save
      </button>
    </mat-card-actions>
  </mat-card>
</section>
